/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
/** Logical atlas names; loaders publish them through contentAssetUrl. */
export let itemSpriteSheets = contentCatalog.source.presentation.sheets

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    itemSpriteSheets: catalog.source.presentation.sheets,
}), next => {
    itemSpriteSheets = next.itemSpriteSheets
})
